export default "__VITE_ASSET__ecf52455__"